import { useState } from 'react';
import { Row, Container, Toast } from 'react-bootstrap';
import logoTescucha from '../images/logo_tescucha.png';
import { useAppSelector } from '../hooks/reduxHooks';
import FormularioExcel from '../components/molecules/FormularioExcel';
import FromularioPdf from '../components/molecules/FormularioPdf';
import '../styles/Formulario.css';
import '../styles/global.css';
import FormTescuchaReadOnly from '../components/organisms/FormTescuchaReadOnly';
import useFormularioExcel from '../hooks/useFormularioExcel';

const Formulario = () => {
  const { isLogged } = useAppSelector(({ adminReducer }) => adminReducer);
  const { foilData } = useAppSelector(({ foilReducer }) => foilReducer);
  const { getFormDataForExcel } = useFormularioExcel();

  const [state, setState] = useState({
    formulario: { folio: '' },
    validated: false,
    showToast: false,
    startDate: new Date(),
    mensajeToast: '',
    idEstatus: 1,
    infoFolio: [],
  });

  return (
    <>
      <div style={{ width: '100%' }}>
        <Toast
          onClose={() => setState(prevState => ({ ...prevState, showToast: false }))}
          show={state.showToast}
          delay={3000}
          autohide
          style={{ position: 'fixed', top: 60, right: 10, zIndex: 100 }}
        >
          <Toast.Header>
            <img src={logoTescucha} className="rounded mr-2" alt="" />
            <strong className="mr-auto">TEscucha</strong>
            <small>Registro de sugerencia</small>
          </Toast.Header>
          <Toast.Body> {state.mensajeToast} </Toast.Body>
        </Toast>
        {isLogged && foilData && (
          <Container className="container-formulario mt-2">
            <Row className="justify-flex-end">
              <FormularioExcel className="mx-2" data={getFormDataForExcel({ foilData })} />
              {foilData?.folio && <FromularioPdf className="m-2" folio={foilData.folio} />}
            </Row>
          </Container>
        )}

        <FormTescuchaReadOnly />
      </div>
    </>
  );
};

export default Formulario;
